export const TERMS_URL = 'https://suporte.iclinic.com.br/iclinic-termos-de-uso';
export const POLICY_URL = 'https://suporte.iclinic.com.br/politica-de-privacidade-iclinic';
